<template>
    <div id="bst-wrap">
        <div class="l-project-wrap l-project-wrap--mypage is-hide">
            <header class="l-header l-header--top">
                <public-page-header />
            </header>
            <section class="l-content-area">
                <div class="l-content">
                    <section class="p-bloc p-bloc--mypage">
                        <div class="p-bloc__content l-wrap__outer">
                            <div class="l-wrap__inner">
                                <section class="p-mypage">
                                    <div class="p-mypage__content">
                                        <div class="mypage-content">
                                            <div class="p-mypage__page mypage-bloc">
                                                <div class="mypage-bloc__content">
                                                    <div class="page__bloc page__bloc--terms c-kiyaku">
                                                        <div class="blog-page">
                                                            <article id="post-inner">
                                                                <header class="article-header">
                                                                    <h1>hubsynchにおいて、コンビニエンスストアでのお支払いをご選択された方へ</h1>
                                                                    <ul class="post-data">
                                                                        <li class="posted"><span
                                                                                class="data-h">POSTED&nbsp;:&nbsp;&nbsp;</span>2014.01.08
                                                                        </li>
                                                                    </ul>

                                                                    <sns-share-links />

                                                                    <div class="eyecatch-img">
                                                                        <span>
                                                                            <img width="860" height="480"
                                                                                src="@/assets/img/static_pages/convenience-payment-method.png"
                                                                                class="attachment-w860-h480 size-w860-h480 wp-post-image"
                                                                                alt="convenience-payment-method">
                                                                        </span>
                                                                    </div>
                                                                </header>

                                                                <!-- post -->
                                                                <section class="article-content">
                                                                    <p>hubsynchにてコンビニエンスストアでのお支払いをご選択される際、コンビニエンスストアのご選択によりお支払方法が異なります。
                                                                    </p>
                                                                    <p>ご利用になるコンビニエンスストア名を選択してください。お支払方法が表示されます。</p>
                                                                    <h4>セブンイレブン(SEVEN-ELEVEN)</h4>
                                                                    <p style="text-align: center;">
                                                                        <img class="aligncenter size-full wp-image-659"
                                                                            alt="sveneleven"
                                                                            src="@/assets/img/static_pages/sveneleven4.png"
                                                                            width="500" height="350">
                                                                    </p>
                                                                    <p>
                                                                        払込票番号（13桁）をメモして、セブン‐イレブン店舗へ行きます。店頭レジにて「インターネット代金の支払い」と伝え、払込票番号を伝えお支払いください。<br>
                                                                        ※払込票番号は商品注文時にhubsynchから配信される「決済申込完了メール」に記載されています。
                                                                    </p>
                                                                    <h4>ローソン(LAWSON)</h4>
                                                                    <p style="text-align: center;"><router-link
                                                                            :to="{ name: 'blog.590' }"><img
                                                                                class="aligncenter size-full wp-image-660"
                                                                                alt="lawson"
                                                                                src="@/assets/img/static_pages/lawson2.png"
                                                                                width="500" height="350"></router-link>
                                                                    </p>
                                                                    <h4>ファミリーマート(FamilyMart)</h4>
                                                                    <p style="text-align: center;">
                                                                        <router-link :to="{ name: 'blog.593' }"><img
                                                                                class="aligncenter size-full wp-image-661"
                                                                                alt="familymart"
                                                                                src="@/assets/img/static_pages/familymart1.png"
                                                                                width="500" height="350"></router-link>
                                                                    </p>
                                                                    <h4>サークルKサンクス(CircleKSunkus)</h4>
                                                                    <p style="text-align: center;"><router-link
                                                                            :to="{ name: 'blog.602' }"><img
                                                                                class="aligncenter size-full wp-image-662"
                                                                                alt="circleksunkus"
                                                                                src="@/assets/img/static_pages/circleksunkus1.png"
                                                                                width="500" height="350"></router-link>
                                                                    </p>
                                                                    <h4>ミニストップ(MINISTOP)</h4>
                                                                    <p style="text-align: center;"><router-link
                                                                            :to="{ name: 'blog.611' }"><img
                                                                                class="aligncenter size-full wp-image-663"
                                                                                alt="ministop"
                                                                                src="@/assets/img/static_pages/ministop1.png"
                                                                                width="500" height="350"></router-link>
                                                                    </p>
                                                                    <h4>セイコーマート(Seicomart)</h4>
                                                                    <p style="text-align: center;"><router-link
                                                                            :to="{ name: 'blog.617' }"><img
                                                                                class="aligncenter size-full wp-image-664"
                                                                                alt="seicomart"
                                                                                src="@/assets/img/static_pages/seicomart1.png"
                                                                                width="500" height="350"></router-link>
                                                                    </p>
                                                                </section>
                                                            </article>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </section>
            <Footer v-if="isLoggedIn"/>
            <PublicFooter v-else/>
        </div>
    </div>
</template>
<script setup>
import PublicPageHeader from "@/components/PublicPageHeader.vue";
import SnsShareLinks from "@/components/SnsShareLinks.vue";
import { ref, onBeforeMount } from "vue";
import { useSessionStore } from "@/stores/sessionStore";
import Footer from "@/components/Footer.vue";
import PublicFooter from "@/components/PublicFooter.vue";

const sessionStore = useSessionStore();
const isLoggedIn = ref(false);
onBeforeMount(async () => {
    isLoggedIn.value = sessionStore.isLoggedIn();
});
</script>